import { render, staticRenderFns } from "./labelInput.vue?vue&type=template&id=12e44126&"
import script from "./labelInput.vue?vue&type=script&lang=js&"
export * from "./labelInput.vue?vue&type=script&lang=js&"
import style0 from "./labelInput.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports